<template>
    <div>
        <el-dropdown trigger="click">
            <span class="el-dropdown-link">
                <span class="hide-mobile">{{ label }}</span> <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item><router-link :to="{name: 'management.user.update-profile'}">{{ $t('generic.logout.buttons.profile') }}</router-link></el-dropdown-item>
                <el-dropdown-item><router-link :to="{name: 'management.user.change-password'}">{{ $t('generic.logout.buttons.changepassword') }}</router-link></el-dropdown-item>
                <el-dropdown-item v-if="canChangePin"><router-link :to="{name: 'management.user.change-pincode'}">{{ $t('generic.logout.buttons.changepin') }}</router-link></el-dropdown-item>
                <el-dropdown-item v-if="showLogout"><router-link :to="{name: 'logout'}" :title="$t('generic.logout.buttons.logout')" :alt="$t('generic.logout.buttons.logout')">{{ $t('generic.logout.buttons.logout') }}</router-link></el-dropdown-item>
                <el-dropdown-item v-if="user.canResetMfaSecret"> <a href="#" v-on:click.prevent="resetUserQrSecret(user.uuid)">{{ $t('generic.logout.buttons.mfaResetQrSecret') }}</a></el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
  import Vue from 'vue'
  export default {
    name: 'DqUsermenu',
    props: {
      label: '',
      showLogout: false
    },
    data: function () {
      return {
        user: undefined
      }
    },
    created () {
      this.user = this.$store.getters['generalSession/getCurrentSession'].data.user
    },
    methods: {
      resetUserQrSecret (userUUID) {
        this.$dataApi().endpoints.user.resetQrSecret(userUUID).then((response) => {
          if (response.status === 200) {
            this.$message.success({message: Vue.t('management.user.messages.qrSecretReset')})
          } else {
            this.$message.warning({message: Vue.t('generic.errors.mfaResetError')})
          }
        })
      },
      checkRoles (roles) {
        const userRoles = this.user.userRoles.map((role) => role.code)

        return roles.some(item => userRoles.includes(item))
      }
    },
    computed: {
      // users that have access to portal and machines
      isMixUser () {
        return this.checkRoles(['manager', 'headmanager'])
      },
      // users that can change PIN (exclude headmanager)
      canChangePin () {
        return this.checkRoles(['manager', 'employee', 'assistantmanager'])
      }
    }
  }
</script>



// WEBPACK FOOTER //
// usermenu.vue?07dc0b9f